import React, {Component, useState} from "react";
import Grid from "@material-ui/core/Grid/Grid";
import {connect} from "react-redux";
import {Badge} from "@material-ui/core";
import Header from "../../components/Header";
import Footer from "../../components/Footer/FooterChefSteps";
import {FormControlLabel, IconButton, Paper, Switch, Typography, Box, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from "@material-ui/core";
import {DatePicker, MuiPickersUtilsProvider} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import {primaryColor, textBlack, webFont} from "../../config/theme";
import Button from "@material-ui/core/Button/Button";
import ArrowRight from "@material-ui/icons/NavigateNext";
import Edit from "@material-ui/icons/EditOutlined";
import Delete from "@material-ui/icons/DeleteOutlined";
import Event from "@material-ui/icons/Event";
import Dot from "@material-ui/icons/FiberManualRecord";
import {setCurrentBooking} from "../../redux/chefs";

import {CHEF_DAY_SCHEDULES, GET_CALENDAR_SLOTS} from "../../graphql/queries/schedule";
import {
  CREATE_DAY_SCHEDULE,
  CREATE_WEEK_SCHEDULE,
  DELETE_DATE_SCHEDULE,
  DELETE_WEEK_SCHEDULE,
  UPDATE_DATE_SCHEDULE,
  UPDATE_WEEK_SCHEDULE,
} from "../../graphql/mutations/schedule";

import {compose, graphql} from "react-apollo";
import * as moment from "moment";
import Slot from "../../components/TimeSlot";
import {GET_CHEF_WEEKLY_SCHEDULES} from "../../graphql/queries/chef";
import {CREATE_CHEF_WEEKLY_SCHEDULE, UPDATE_CHEF_WEEKLY_SCHEDULE} from "../../graphql/mutations/chef";
import {client} from "../../config/apollo";
import {CHEF_BOOKINGS} from "../../graphql/queries/bookings";
import {BOOKING_STATUS} from "../../config/constants";

import format from 'date-fns/format'
import {NotificationManager} from "react-notifications";
import { setScheduleMonth } from '../../redux/schedule';
import {getChef, getUser} from "../../redux/user";
import UPDATE_CHEF from "../../graphql/mutations/chef/update_chef";
import Breadcrumbs from "../../components/Breadcrumbs";
import {checkStartEnd} from "../../utils/common-methods";

class FrDateFnsUtils extends DateFnsUtils {
  startOfMonth(date) {
    return moment(date).startOf('month').toDate();
  }

  getDatePickerHeaderText(date) {
    return format(date, 'd MMMM', {locale: this.locale})
  }
}

let upcomingMonths = [];

const showEngagementMonth = (engagement) => {
  const engagementMonth = moment(new Date(engagement.date)).format("MMMM , YYYY");
  const index = upcomingMonths.findIndex(item => item === engagementMonth);

  if (index < 0) {
    upcomingMonths.push(engagementMonth);
    return engagementMonth;
  }
};


const dishNames = (engagement) => {
  let dishNames = "";

  if (!!engagement && !!engagement.dishes) {
    const names = engagement.dishes.map(dish => dish.dishName.toLowerCase());
    dishNames = names.toString().replace(/,/g, ", ");
  }

  return dishNames;
};

const Engagement = ({engagement, onViewDetails}) => (
  <div>
    <div>
      {/*<p style={{
        fontSize: 20,
        fontFamily: webFont
      }}>{showEngagementMonth(engagement)}</p>*/}
      <div>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          margin: '10px auto'
        }}>
          <div><p style={{
            fontFamily: webFont,
            fontSize: 24,
            fontWeight: 500,
            margin: 0,
            width: 30,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center'
          }}>
            {moment(new Date(engagement.date)).format("DD")}
            <br />
            <span style={{
              fontFamily: webFont,
              fontSize: 16,
              fontWeight: 500,
            }}>
              {moment(new Date(engagement.date)).format("MMM")}
            </span>
          </p></div>
          <div style={{
            width: 380,
            height: 64,
            opacity: 0.7,
            borderRadius: 6,
            padding: 5,
            paddingLeft: 5,
            backgroundColor: primaryColor,
            marginLeft: 10,
            display: "flex",
            justifyContent: 'space-between',
            alignItems: 'center'
          }}>
            <div>
              <div  data-test-id={"engmetuser"} style={{
                display: 'flex',
                alignItems: 'center'

              }}><p style={{
                margin: 0,
                fontFamily: webFont,
                fontSize: 15,
                fontWeight: 500,
                color: '#ffffff'
              }}>{engagement.userName}</p>
                <Dot style={{
                  width: 10,
                  height: 10,
                  color: '#ffffff',
                  paddingLeft: 2,
                  paddingRight: 2

                }}/>
                <p style={{
                  margin: 0,
                  fontFamily: webFont,
                  fontSize: 12,
                  fontWeight: 500,
                  color: '#ffffff'
                }}>{dishNames(engagement)}</p>
              </div>
              <div><p style={{
                margin: 0,
                fontFamily: webFont,
                fontSize: 15,
                fontWeight: 500,
                color: '#ffffff',
                padding: 5
              }}> {`${moment(engagement.timeSlot.start, "hh:mm a").format("LT")}`}-
                {`${moment(engagement.timeSlot.end, "hh:mm a").format("LT")}`}</p></div>
            </div>
            <div>
              <IconButton data-test-id={"engmnt-navid"} style={{
                color: '#ffffff'
              }} onClick={onViewDetails}>
                <ArrowRight/>
              </IconButton>

            </div>
          </div>

          <div>

          </div>
        </div>
      </div>

    </div>
  </div>
);

class Schedule extends Component {

  constructor(props) {
    super(props);
    let {search} = props.location;
    let searchArr = [];
    if (search.length) {
      search = search.substr(1);
      searchArr = search.split('=');
    }

    this.state = {
      selectedDate: new Date(),
      isLoading: false,
      createSlot: false,
      option: searchArr.length === 2 ? parseInt(searchArr[1]) : 1,
      daysToSelect: [
        {name: "S", value: "SUNDAY", selected: false},
        {name: "M", value: "MONDAY", selected: false},
        {name: "T", value: "TUESDAY", selected: false},
        {name: "W", value: "WEDNESDAY", selected: false},
        {name: "T", value: "THURSDAY", selected: false},
        {name: "F", value: "FRIDAY", selected: false},
        {name: "S", value: "SATURDAY", selected: false}
      ],
      selectedDay: {name: "S", value: "SUNDAY", selected: false},
      createWeekSelectedDays: [],
      createSlotWeek: false,
      updateSlotWeek: false,
      updateSlot: false,
      slotToUpdate: {},
      weekSlotToUpdate: {},
      engagements: [],
      datePickerRef: false,
      isActive: false
    };
  }

  componentDidMount() {
    let {search} = this.props.location;
    let searchArr = [];
    if (search.length) {
      search = search.substr(1);
      searchArr = search.split('=');
    }

    if (searchArr.length === 2) {
      if (searchArr[1] == 2) { this.fetchEngagements(); upcomingMonths.splice(0, upcomingMonths.length);
        upcomingMonths.length = 0; }
    }
  }

  static getDerivedStateFromProps(props, state) {
    const returnState = {};

    if (props.weekSchedules) {
      if (props.weekSchedules.chefSchedule) {
        if (props.weekSchedules.chefSchedule.daySchedules) {
          if (props.weekSchedules.chefSchedule.daySchedules.length > 0) {
            const { daysToSelect } = state;
            const index = daysToSelect.findIndex(item => item.value === props.weekSchedules.chefSchedule.daySchedules[0].day);
            if (index > -1) {
              if (JSON.stringify(state.selectedDay) === JSON.stringify({name: "S", value: "SUNDAY", selected: false})) {
                const selectedDay = daysToSelect[index];
                selectedDay.selected = true;
                returnState.selectedDay = selectedDay;
              }
            }
          }
        }
      }
    }

    if (props.chef) {
      if (props.chef.active) { returnState.isActive = true; }
      else returnState.isActive = false;
    }

    return returnState;
  }

  onViewDetails = booking => {
    const {dispatch} = this.props;
    dispatch(setCurrentBooking(booking));
    this.props.history.push("/home/chef-booking-status?ps=schedule");
  };

  handleMonthChange = date => {
    const updatedMonth = moment(date).format('MM');
    this.props.dispatch(setScheduleMonth(updatedMonth));
  };

  fetchByDate = day => {
    this.props.monthlySlots.refetch();
    this.props.schedules
      .refetch({...{date: day}})
      .then(res => {
      })
      .catch(err => {
        console.log(err);
      });
  };

  handleDateChange = date => {
    const {userId: chefId} = this.props;
    this.setState({selectedDate: new Date(date), option: 1});
    let day = moment(date || new Date()).format("YYYY-MM-DD");
    this.fetchByDate(day);
  };

  updateDateSchedule = slot => {
    const start =
      slot.from === "AM"
        ? slot.fromTime
        : `${parseInt(slot.fromTime.split(":")[0]) + 12}:${
          slot.fromTime.split(":")[1]
        }`;
    const end =
      slot.to === "AM"
        ? slot.toTime
        : `${parseInt(slot.toTime.split(":")[0]) + 12}:${
          slot.toTime.split(":")[1]
        }`;
    const {updateDaySchedule, userId: chefId} = this.props;

    const {selectedDate, active: available} = this.state;
    const date = moment(selectedDate).format("YYYY-MM-DD");
    if (!checkStartEnd(start, end)) return NotificationManager.error('Enter a valid start and end time.', 'Chef Schedules');
    updateDaySchedule({
      variables: {chefId, date, slot: {start, end}}
    })
      .then(res => {
        this.fetchByDate(date);
        this.setState({updateSlot: false, createSlot: false});
      })
      .catch(err => {
        let errorObj = JSON.parse(JSON.stringify(err));
        console.log(errorObj);
        if (errorObj.graphQLErrors) {
          errorObj.graphQLErrors.map(error => {
            error.message = error.message.replace(/GraphQL error:/gi, '');
            NotificationManager.error(error.message, "Schedule");
          });

        }
      });
  };

  deleteWeekSchedule = slot => {
    const {deleteWeeklySchedule, userId: chefId, weekSchedules} = this.props;
    const {
      selectedDay: {value}
    } = this.state;

    const {start, end} = slot;
    deleteWeeklySchedule({
      variables: {chefId, day: value, slot: {start, end}}
    })
      .then(res => {
        weekSchedules.refetch();
      })
      .catch(err => {
        let errorObj = JSON.parse(JSON.stringify(err));
        console.log(errorObj);
        if (errorObj.graphQLErrors) {
          errorObj.graphQLErrors.map(error => {
            error.message = error.message.replace(/GraphQL error:/gi, '');
            NotificationManager.error(error.message, "Schedule");
          });
        }

      });
  };

  deleteDateSchedule = slot => {
    const {deleteDaySchedule, userId: chefId, schedules} = this.props;
    const {start, end, date} = slot;
    deleteDaySchedule({
      variables: {chefId, date, slot: {start, end}}
    })
      .then(res => {
        schedules.refetch();
      })
      .catch(err => {
        let errorObj = JSON.parse(JSON.stringify(err));
        console.log(errorObj);
        if (errorObj.graphQLErrors) {
          errorObj.graphQLErrors.map(error => {
            error.message = error.message.replace(/GraphQL error:/gi, '');
            NotificationManager.error(error.message, "Schedule");
          });
        }
      });
  };

  weekSlotUpdate = slot => {
    const {userId: chefId, updateWeekSchedule, weekSchedules} = this.props;
    const {selectedDay} = this.state;
    const {value: day} = selectedDay;
    const start =
      slot.from === "AM"
        ? slot.fromTime
        : `${parseInt(slot.fromTime.split(":")[0]) + 12}:${
          slot.fromTime.split(":")[1]
        }`;
    const end =
      slot.to === "AM"
        ? slot.toTime
        : `${parseInt(slot.toTime.split(":")[0]) + 12}:${
          slot.toTime.split(":")[1]
        }`;
    const payload = {chefId, days: [day], slot: {start, end}};

    if (!checkStartEnd(start, end)) return NotificationManager.error('Enter a valid start and end time.', 'Chef Schedules');

    updateWeekSchedule({variables: payload})
      .then(res => {
        this.setState({updateSlotWeek: false});
        weekSchedules.refetch();
      })
      .catch(err => {
        this.setState({updateSlotWeek: false});
        let errorObj = JSON.parse(JSON.stringify(err));
        console.log(errorObj);
        if (errorObj.graphQLErrors) {
          errorObj.graphQLErrors.map(error => {
            error.message = error.message.replace(/GraphQL error:/gi, '');
            NotificationManager.error(error.message, "Schedule");
          });
        }
        console.log("error in week schdule update", err);
      });
  };

  updateWeekSlot = slot => {
    const {start, end} = slot;
    let to = "PM";
    let from = "AM";
    let fromTime = "";
    let toTime = "";

    if (parseInt(start.split(":")[0]) > 12) {
      from = "PM";
      let hour = parseInt(start.split(":")[0]) - 12;
      let mins = start.split(":")[1];
      fromTime = hour <= 9 ? "0" + hour + ":" + mins : hour + ":" + mins;
    } else {
      from = "AM";
      fromTime = start;
    }

    if (parseInt(end.split(":")[0]) > 12) {
      to = "PM";
      let hour = parseInt(end.split(":")[0]) - 12;
      let mins = end.split(":")[1];
      toTime = hour <= 9 ? "0" + hour + ":" + mins : hour + ":" + mins;
    } else {
      to = "AM";
      toTime = end;
    }

    this.setState({
      weekSlotToUpdate: {from, fromTime, to, toTime, start, end},
      updateSlotWeek: true
    });
  };

  updateSlot = slot => {
    const {start, end} = slot;
    let to = "PM";
    let from = "AM";
    let fromTime = "";
    let toTime = "";
    if (start > 12) {
      from = "PM";
      fromTime = start - 12;
    } else {
      from = "AM";
      fromTime = start;
    }
    if (end > 12) {
      to = "AM";
      toTime = end - 12;
    } else {
      to = "PM";
      toTime = end;
    }
    this.setState({
      slotToUpdate: {from, fromTime, to, toTime},
      updateSlot: true
    });
  };

  handelCreateSchedule = async ({fromTime, from, to, toTime}) => {
    const {
      userId: chefId,
      createDaySchedule,
      schedules,
      monthlySlots
    } = this.props;
    const {selectedDate, active: available} = this.state;
    const date = moment(selectedDate).format("YYYY-MM-DD");

    const start = moment(fromTime + ' ' + from, 'hh:mm A').format('HH:mm');
    const end = moment(toTime + ' ' + to, 'hh:mm A').format('HH:mm');

    if (!checkStartEnd(start, end)) return NotificationManager.error('Enter a valid start and end time.', 'Chef Schedules');

    const payload = {
      chefId,
      date,
      dateSchedule: {
        date,
        slots: [
          {
            start,
            end
          }
        ],
        available: true
      }
    };

    try {
      const res = await createDaySchedule({variables: payload});
      if (res) {
        this.setState({createSlot: false});

        this.fetchByDate(date);
      }
    } catch (err) {
      let errorObj = JSON.parse(JSON.stringify(err));
      console.log('errorObj: ', errorObj);
      if (
        errorObj.message ===
        "GraphQL error: Schedule for a said day already exists"
      ) {
        this.updateDateSchedule({fromTime, from, to, toTime});
        this.setState({createSlot: false});

        console.log(errorObj.message);
      } else {
        errorObj.message = errorObj.message.replace(/GraphQL error:/gi, '');
        NotificationManager.error(errorObj.message, 'Schedule');
      }
    }
  };

  updateWeekSchedule = async slot => {
    const {updateWeeklySchedule, userId: chefId, weekSchedules} = this.props;
    const {selectedDay} = this.state;

    const start = moment(slot.fromTime + ' ' + slot.from, 'hh:mm A').format('HH:mm');
    const end =moment(slot.toTime + ' ' + slot.to, 'hh:mm A').format('HH:mm');

      let payload = {
        chefId,
        days: [selectedDay.value],
        slot: {
          start,
          end
        }
      };

    try {
      const updateResp = await updateWeeklySchedule({
        variables: payload
      });
      if (updateResp) {
        await weekSchedules.refetch();
      }
    } catch (err) {
      let errorObj = JSON.parse(JSON.stringify(err));
    }
  };

  createWeekSchedule = async slot => {
    const {createWeeklySchedule, updateWeeklySchedule, userId: chefId, weekSchedules,chefSchedule} = this.props;
    const {createWeekSelectedDays, selectedDay} = this.state;

    const start = moment(slot.fromTime + ' ' + slot.from, 'hh:mm A').format('HH:mm');
    const end =moment(slot.toTime + ' ' + slot.to, 'hh:mm A').format('HH:mm');

    let payload = [];
    if (createWeekSelectedDays.length > 0) {
      createWeekSelectedDays.forEach(weekDay => {
        /*const weekSched = {
         day: weekDay.value,
         slots: [ {start, end} ]
         };

         payload.push(weekSched);*/
        payload.push(weekDay.value)
      });
    }
    else {
      alert("Please choose days to create slot");
      return;
    }


    /*let payload2 = await {
     chefId,
     weekschedule: {
     daySchedules: payload
     }
     };*/

    let payload2 = {
      chefId,
      days: payload,
      slot: {
        start,
        end
      }
    };

    try {
      const updateResp = await updateWeeklySchedule({
        variables: payload2
      });
      /* const updateResp = await createWeeklySchedule({
       variables: payload2
       });*/

      if (updateResp) {
        this.setState({createSlotWeek: false});
        await weekSchedules.refetch();
      }
    } catch (err) {
      console.log(err);
      this.setState({createSlotWeek: false});

      let errorObj = JSON.parse(JSON.stringify(err));
    }
  };

  openDatePicker = e => {
    this.setState({datePickerRef: !this.state.datePickerRef})
  };

  haveSlots = day => {
    const {
      weekSchedules: {chefSchedule}
    } = this.props;

    if (!chefSchedule)
      return false;

    let currentDay = chefSchedule.daySchedules.find(schedule => {
      return schedule.day === day.value;
    });
    return currentDay && currentDay.slots.length > 0;
  };

  haveWeekCreateSlots = day => {
    const {
      createWeekSelectedDays
    } = this.state;

    if (!createWeekSelectedDays)
      return false;

    let currentDay = createWeekSelectedDays.findIndex(item => item.value === day.value);
    if (currentDay > -1) {
      return true;
    }

    return false;
  };

  createSlotHandleDays = day => {
    const {
      createWeekSelectedDays
    } = this.state;

    if (!createWeekSelectedDays)
      return false;

    let currentDay = createWeekSelectedDays.findIndex(item => item.value === day.value);

    if (currentDay < 0) {
      day.selected = true;
      createWeekSelectedDays.push(day);
    }
    else {
      createWeekSelectedDays.splice(currentDay, 1);
    }

    this.setState({ createWeekSelectedDays });
  };

  isInSchedule = date => {
    const {
      monthlySlots: {getCalendarSlots}
    } = this.props;


    let isAvailable = false;

    if (getCalendarSlots)
      isAvailable = getCalendarSlots.find(day => {
        return day.date === moment(date).format("YYYY-MM-DD");
      });

    return !!isAvailable;
  };

  fetchEngagements = () => {
    const {userId: chefId} = this.props;

    client
      .query({
        query: CHEF_BOOKINGS,
        variables: {
          chefId,
          status: BOOKING_STATUS.ACCEPTED,
          startDate: moment(new Date()).format("YYYY-MM-DD"),
          bookingCount: 10
        },
        fetchPolicy: "network-only"
      })
      .then(resp => {
        if (resp.data) {
          if (resp.data.chefBookings) {
            const {
              chefBookings: {bookings}
            } = resp.data;

            if (bookings.length) {
              bookings.sort((a, b) => a.date - b.date);
            }

            this.setState({
              engagements: bookings || []
            });
          }
        }
      })
      .catch(err => {
        console.error("CHEF Bookings: ", err);
        this.setState({loading: false});
        console.log(JSON.parse(JSON.stringify(err)));
      });
  };

  renderWrappedWeekDay = (date, selectedDate, dayInCurrentMonth, dayComponent) => {
    let inDate = moment(date);
    const inCompDate = inDate.format("YYYY") + "-" + inDate.format("MM") + "-" + inDate.format("DD");
    inDate = moment(inCompDate);
    let today = moment(new Date());
    const compToday = today.format("YYYY") + "-" + today.format("MM") + "-" + today.format("DD");
    today = moment(compToday);

    if (inDate.isBefore(today)) {
      return <Badge>{dayComponent}</Badge>;
    }
    else {
      return <Badge badgeContent={<span
        style={{
          fontSize: 30,
          fontWeight: 500,
          color: this.isInSchedule(date) ? primaryColor : "white"
        }}
      >
                .
                </span>}>{dayComponent}</Badge>;
    }
  };

  changeActiveStatus() {
    let {updateChef, chef,userId,dispatch} = this.props;

    let chefPayload = {
      userId: this.props.userId,
      active: !chef.active,
    };

    this.setState({isLoading: true});

    updateChef({
      variables: {chef: chefPayload}
    }).then(res => {
      dispatch(getChef(userId));
      this.setState({isLoading: false});
    }).catch(err => {
      console.log(err);
      console.log(JSON.parse(JSON.stringify(err)));
      this.setState({isLoading: false});
    });
  }

  render() {
    const {
      schedules: {chefDaySchedule, loading},
      weekSchedules: {chefSchedule, loading: loading2},
      chef
    } = this.props;

    const {option, daysToSelect, selectedDay, engagements,isLoading} = this.state;

    let weekSlots = [];
    const weekScheduleSlots =
      !!chefSchedule &&
      !!chefSchedule.daySchedules &&
      !!chefSchedule.daySchedules.length;

    if (weekScheduleSlots) {
      let currentDay = chefSchedule.daySchedules.find(schedule => {
        return schedule.day === selectedDay.value;
      });
      if (!!currentDay) {
        weekSlots = currentDay.slots;
      }
    }
    let monthlyEngagements = [[], [], [], [], [], [], [], [], [], [], [], []];

    engagements.forEach(eng => {
      const date = moment(new Date(1555459200000));
      monthlyEngagements[parseInt(date.format("M")) - 1].push(eng);
    });

    return (
      <div>
        <Grid container>
          <Grid item lg={12} xl={12} xs={12}>
            <Header history={this.props.history} loading={loading || loading2 || isLoading}/>
          </Grid>

          <Grid container justify={'center'}>
            <div className="dish-container-custom">
              <Grid
                item
                direction={'column'}
                style={{
                  paddingTop: "40px",
                  /*display: "flex",*/
                  justifyContent: "center"
                }}
              >
                <Grid item xs={12} style={{ marginBottom: 30}}>
                  <Breadcrumbs childRoutes={[
                    {
                      display: 'Schedule',
                      link: 'home/chef-schedule'
                    }
                  ]} />
                </Grid>
                <Grid container alignItems="flex-start" style={{ marginTop: 30 }}>
                  <Grid item xs={3} md={4} lg={4} xl={5} style={{ borderBottom: '1px solid #000', marginTop: 20 }} />
                  <Grid item xs={6} md={4} lg={4} xl={2}>
                    <Typography variant="h5" style={{
                      fontFamily: webFont, fontWeight: 500, fontSize: '30px', marginBottom: 20,
                      textAlign: 'center'
                    }}>
                      My schedule
                    </Typography>
                  </Grid>
                  <Grid item xs={3} md={4} lg={4} xl={5} style={{ borderBottom: '1px solid #000', marginTop: 20 }}  />
                </Grid>
                <Grid item xs={12} xl={12} lg={12} className="status-header-status">
                  <Grid container style={{display: "flex"}} alignContent='center' alignItems='center' justify='flex-start' className="chef-status">
                    <p
                      style={{
                        fontFamily: webFont,
                        fontWeight: 1,
                        fontSize: '18px',
                        marginRight: 60,
                      }}
                    >
                      Status
                    </p>

                    <FormControlLabel
                      style={{fontFamily: webFont, fontSize: '18px'}}
                      control={
                        <Switch
                          data-test-id={"chefact-id"}
                          checked={this.state.isActive}
                          onChange={() => {
                            this.changeActiveStatus();
                          }}
                        />
                      }
                      label={chef && chef.active ? 'Active' : 'Inactive'}
                      labelPlacement="start"
                    />
                  </Grid>
                </Grid>


                <Grid container xs={12} direction={'row'}>
                  <Grid item lg={5} xl={5} xs={12} md={5} sm={12}>
                    <Grid item sm={12} xs={12} md={12}>
                      <Button
                        className="chef-schedule-header-button-font"
                        data-test-id={"revsch-id"}
                        variant="outlined"
                        color={this.state.option === 3 ? "primary" : "default"}
                        style={{
                          height: 68,
                          marginBottom: 30,
                          textTransform: "none",
                          justifyContent: "space-between",
                          fontFamily: webFont,
                          backgroundColor: this.state.option === 3 ? '#fce7d1' : '#fff',
                        }}
                        fullWidth
                        onClick={() => this.setState({option: 3, createSlot: false})}
                      >
                        <span style={{color: textBlack, fontWeight: 'normal'}} className="chef-schedule-header-button-font">
                          Revise weekly schedule
                        </span>
                        <span style={{color: textBlack, lineHeight: 0,}}>
                          <ArrowRight/>
                        </span>
                      </Button>
                    </Grid>
                    <Grid item sm={12} xs={12} md={12}>
                      <Button
                        className="chef-schedule-header-button-font"
                      data-test-id={"viewupgeng-id"}
                        variant="outlined"
                        color={this.state.option === 2 ? "primary" : "default"}
                        style={{
                          height: 68,
                          marginBottom: 30,
                          textTransform: "none",
                          justifyContent: "space-between",
                          fontFamily: webFont,
                          backgroundColor: this.state.option === 2 ? '#fce7d1' : '#fff',
                        }}
                        fullWidth
                        onClick={() => {
                          upcomingMonths.splice(0, upcomingMonths.length);
                          upcomingMonths.length = 0;
                          this.setState({option: 2, createSlot: false, createSlotWeek: false});
                          this.fetchEngagements();
                        }}
                      >
                        <span
                          className="chef-schedule-header-button-font"
                          style={{
                            color: textBlack,
                            fontWeight: 'normal',
                          }}
                        >
                          View upcoming engagements
                        </span>
                        <span style={{color: textBlack, lineHeight: 0}}>
                          <ArrowRight/>
                        </span>
                      </Button>
                    </Grid>
                    <Grid item sm={12} xs={12} md={12}>
                      <Button
                        className="chef-schedule-header-button-font"
                        data-test-id={"choosedate-id"}
                        variant="outlined"
                        color={this.state.option === 1 ? "primary" : "default"}
                        style={{
                          height: 68,
                          marginBottom: 30,
                          textTransform: "none",
                          justifyContent: "space-between",
                          fontFamily: webFont,
                          backgroundColor: this.state.option === 1 ? '#fce7d1' : '#fff',
                        }}
                        fullWidth
                        onClick={() => {
                          this.setState({ createSlotWeek: false });
                          this.openDatePicker();
                        }}
                      >
                        <Box display="flex" justifyContent="space-between" alignItems="center" width="100%">
                              <span
                                className="chef-schedule-header-button-font"
                                style={{
                                  color: textBlack,
                                  float: 'left',
                                  marginRight: 10,
                                  fontWeight: 'normal',
                                }}
                              >
                                  {moment(this.state.selectedDate).format("MMMM DD, YYYY")}
                              </span>
                          <Box className="calendar-col" display="flex" alignItems="center">
                            <p
                              className="chef-schedule-header-button-font"
                              style={{
                                color: primaryColor,
                                float: 'left',
                                marginRight: 10,
                                textTransform: 'none',
                                fontWeight: 'normal',
                              }}
                            >
                              Choose date
                            </p>
                            <Event style={{marginTop: 3}} />
                          </Box>
                        </Box>
                      </Button>

                      {this.state.datePickerRef &&

                      <MuiPickersUtilsProvider utils={FrDateFnsUtils}>
                        <DatePicker
                          variant="dialog"
                          onlyCalendar
                          disablePast
                          style={{
                            marginBottom: 30,
                            fontFamily: webFont,
                            fontWeight: 'normal',
                            fontSize: "16px",
                            width: "100%"
                          }}
                          value={this.state.selectedDate}
                          onChange={this.handleDateChange}
                          onMonthChange={this.handleMonthChange}
                          renderDay={this.renderWrappedWeekDay}
                          open={this.state.datePickerRef}
                          onAccept={(d) => {
                            this.openDatePicker();
                          }}
                          onClose={() => {
                            this.openDatePicker();
                          }}
                          // minDate={new Date(new Date().getDate() - 1)}
                          minDateMessage={"Please select valid date !"}
                        />
                      </MuiPickersUtilsProvider>}
                    </Grid>
                  </Grid>

                  <Grid item lg={1} xl={1} xs={0} sm={0} md={1} />

                  <Grid item lg={5} xl={5} xs={12} sm={12} md={6}>
                    <Grid item sm={12} xs={12} md={12}/>
                    <Grid item sm={12} xs={12} md={12}>
                      {option === 1 && (
                        <Grid container direction="column" justify={"space-between"}>
                          <Typography
                            style={{fontFamily: webFont, fontSize: '24px', fontWeight: 500, marginBottom: 8,}}
                          >
                            {moment(this.state.selectedDate).format("MMMM DD, YYYY")}
                          </Typography>
                          <Typography style={{fontFamily: webFont, fontSize: '14px', marginBottom: 30}}>
                            This will be your schedule for private engagements for this date.
                          </Typography>
                          {!!chefDaySchedule &&
                          chefDaySchedule.slots &&
                          !!chefDaySchedule.slots.length &&
                          chefDaySchedule.slots.map((slot, i) => (
                            <ScheduleButton
                              key={"schedule" + i}
                              startTime={slot.start}
                              endTime={slot.end}
                              /*onEditClick={() =>
                              this.updateSlot({
                              ...slot,
                              date: chefDaySchedule.date
                              })
                              }*/
                              onDelete={() =>
                                this.deleteDateSchedule({
                                  ...slot,
                                  date: chefDaySchedule.date
                                })
                              }
                              /*onEditClick={() => this.updateSlot(slot)}*/
                            />
                          ))}
                          {this.state.updateSlot && (
                            <Slot
                              onCreate={this.createWeekSchedule}
                              title={"Update Slot"}
                              selectedDays={[]}
                              isUpdate={true}
                              to={this.state.slotToUpdate.to}
                              toTime={this.state.slotToUpdate.toTime}
                              from={this.state.slotToUpdate.from}
                              fromTime={this.state.slotToUpdate.fromTime}
                              onCancel={() => this.setState({updateSlot: false})}
                            />
                          )}
                        </Grid>
                      )}
                      {option === 2 && (
                        <div>

                          <div  data-test-id={"engmttitle-id"} ><p style={{
                            fontFamily: webFont,
                            fontSize: 24,
                            fontWeight: 500,
                            margin: 0
                          }}>{engagements.length !==0 ? "Upcoming engagements" : "No engagements found" }</p></div>



                          {monthlyEngagements.map(eng => (
                            <div   data-test-id={"engmtviewdet-id"} >
                              {eng.map((e, idx) => (
                                <Engagement key={idx + 'eng'} engagement={e}
                                            onViewDetails={() => this.onViewDetails(e)}/>))}
                            </div>
                          ))}
                        </div>

                      )}
                      {option === 3 && (
                        <Grid container direction="column">
                          <Grid item md={12} xs={12}>
                            <Typography
                              style={{fontFamily: webFont, fontSize: '24px', fontWeight: 500, marginBottom: 16,}}
                            >
                              Revise weekly schedule
                            </Typography>
                          </Grid>
                          <Grid item md={12} xs={12}>
                            <Typography style={{fontFamily: webFont, fontSize: '14px'}}>
                              This will be your weekly schedule for private engagements.
                            </Typography>
                          </Grid>
                          <Grid item md={12} xs={12} style={{
                            marginTop: 70,
                            paddingBottom: 24,
                            borderBottom: '1px solid #dedddd',
                            display: 'flex',
                            justifyContent: 'space-between',
                          }}>
                            {daysToSelect.map(day => (
                              <button
                                type={"button"}
                                data-test-id={"revsch-day-id"}
                                key={day.value}
                                className="chef-schedule-day-btn"
                                style={{
                                  backgroundColor: this.haveSlots(day) ? this.state.selectedDay === day ? primaryColor : "#fcb268" : "white",
                                  width: 40,
                                  height: 40,
                                  borderRadius: '50%',
                                  borderColor: this.haveSlots(day) ? this.state.selectedDay === day ? primaryColor : "#fcb268" : primaryColor,
                                  borderStyle: "solid",
                                  borderWidth: 2,
                                  fontSize: 15,
                                  fontFamily: webFont,
                                  boxShadow: 'none',
                                  color: this.haveSlots(day) ? "white" : primaryColor,
                                  '&:last-child': {
                                    margin: '0',
                                  },
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center'
                                }}
                                onClick={() =>
                                  this.setState({
                                    selectedDay: day,
                                    updateSlotWeek: false
                                  })
                                }
                              >
                                {day.name}
                              </button>
                            ))}
                          </Grid>
                          <Grid item md={12} xs={12} style={{marginTop: 40}}>
                            <Grid container direction="column">
                              {!!weekScheduleSlots &&
                              !!weekSlots.length &&
                              weekSlots.map((slot, i) => (
                                <ScheduleButton
                                data-test-id={"revschrep-day-id"}
                                  key={"schedule" + i}
                                  startTime={slot.start}
                                  endTime={slot.end}
                                  /*onEditClick={() => this.updateWeekSlot(slot)}*/
                                  onDelete={() => this.deleteWeekSchedule(slot)}
                                />
                              ))}
                            </Grid>

                            {this.state.createSlotWeek && (
                              <Slot
                                daysToSelect={daysToSelect}
                                haveSlots={this.haveWeekCreateSlots}
                                onCreate={this.createWeekSchedule}
                                onChooseButton={this.createSlotHandleDays}
                                title={"Create slot"}
                                selectedDays={[]}
                                showDays={true}
                                onCancel={() =>
                                  this.setState({createSlotWeek: false})
                                }
                              />
                            )}

                            {this.state.updateSlotWeek && (
                              <Slot
                                onCreate={this.weekSlotUpdate}
                                title={"Update Slot"}
                                selectedDays={[]}
                                isUpdate={true}
                                to={this.state.weekSlotToUpdate.to}
                                toTime={this.state.weekSlotToUpdate.toTime}
                                from={this.state.weekSlotToUpdate.from}
                                fromTime={this.state.weekSlotToUpdate.fromTime}
                                onCancel={() =>
                                  this.setState({updateSlotWeek: false})
                                }
                              />
                            )}

                            {!this.state.createSlotWeek && !this.state.updateSlotWeek && (
                              <Button
                                data-test-id="createslot-id"
                                variant="contained"
                                style={{
                                  fontSize: 20,
                                  padding: '11.5px 15px',
                                  textTransform: 'none',
                                  color: '#fff'
                                }}
                                color="primary"
                                fullWidth
                                onClick={() =>
                                  this.setState({createSlotWeek: true, createSlot: false})
                                }
                              >
                                <div>
                                  <p style={{margin: 0, fontFamily: webFont, fontWeight: 'normal'}}>+ Create slot</p>
                                </div>
                              </Button>
                            )}


                          </Grid>
                        </Grid>
                      )}
                    </Grid>

                    <Grid item sm={12} xs={12} md={12}>
                      {this.state.createSlot && (
                        <Slot
                          onCreate={this.handelCreateSchedule}
                          title="Create slot"
                          selectedDays={[]}
                          onCancel={() => this.setState({createSlot: false})}
                        />
                      )}

                      {!this.state.createSlot &&
                      option === 1 &&
                      !this.state.updateSlot && (
                        <Button
                          variant="contained"
                          style={{
                            fontSize: 20,
                            padding: '11.5px 15px',
                            textTransform: 'none',
                            fontFamily: webFont,
                            color: '#fff'
                          }}
                          color="primary"
                          fullWidth
                          onClick={() => this.setState({createSlot: true, createSlotWeek: false})}
                        >
                          <div>
                            <p style={{margin: 0, fontFamily: webFont, fontWeight: 'normal'}}>+ Create slot</p>
                          </div>
                        </Button>
                      )}
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              </div>
            </Grid>
          <Footer/>
        </Grid>
      </div>
    );
  }
}

const ScheduleButton = props => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <Grid style={{paddingBottom: 30}}>
      <Dialog
        open={isOpen}
        onClose={() => setIsOpen(false)}
        aria-labelledby="alert-dialog-delete-title"
        aria-describedby="alert-dialog-schedule-delete"
      >
        <DialogTitle id="alert-dialog-title">{"Are you sure you want to delete this schedule?"}</DialogTitle>
        <DialogActions>
          <Button onClick={props.onDelete} color="primary">
            Yes
          </Button>
          <Button onClick={() => setIsOpen(false)} color="primary" autoFocus>
            No
          </Button>
        </DialogActions>
      </Dialog>
      <Paper
        variant="contained"
        style={{
          display: "flex",
          justifyContent: "space-between",
          padding: '6px 4px 6px 20px',
          background: 'rgba(255, 128, 0, 0.8)',
          boxShadow: 'none',
        }}
      >
        <Box display="flex" alignItems="center">
          <p style={{color: "white", margin: 0, fontWeight: 'normal', fontSize: 20,}}>
            {`${moment(props.startTime, "hh:mm").format("LT")}`}-
            {`${moment(props.endTime, "hh:mm").format("LT")}`}
          </p>
        </Box>
        <div>
          {/*<IconButton onClick={props.onEditClick}>
           <Edit style={{color: "white"}}/>
           </IconButton>*/}
          <IconButton data-test-id={"del-id"} onClick={() => setIsOpen(true)}>
            <Delete style={{color: "white"}}/>
          </IconButton>
        </div>
      </Paper>
    </Grid>
  );

};


const mapStateToProps = state => {
  return {
    userId: state.auth.userId,
    chef: state.user.chef,
    scheduleMonth: state.schedule.scheduleMonth,
  };
};

const ChefScheduleWithData = compose(
  graphql(CREATE_DAY_SCHEDULE, {name: "createDaySchedule"}),
  graphql(CREATE_CHEF_WEEKLY_SCHEDULE, { name: "createWeeklySchedule" }),
  graphql(UPDATE_CHEF, { name: "updateChef" }),
  graphql(UPDATE_DATE_SCHEDULE, {name: "updateDaySchedule"}),
  graphql(DELETE_DATE_SCHEDULE, {name: "deleteDaySchedule"}),
  graphql(UPDATE_CHEF_WEEKLY_SCHEDULE, {name: "updateWeeklySchedule"}),
  graphql(DELETE_WEEK_SCHEDULE, {name: "deleteWeeklySchedule"}),
  graphql(UPDATE_WEEK_SCHEDULE, {name: "updateWeekSchedule"}),

  graphql(CHEF_DAY_SCHEDULES, {
    name: "schedules",
    options: props => ({
      variables: {
        chefId: props.userId,
        date: moment(new Date()).format("YYYY-MM-DD")
      },
      fetchPolicy: "network-only"
    })
  }),
  graphql(GET_CHEF_WEEKLY_SCHEDULES, {
    name: "weekSchedules",
    options: props => ({
      variables: {
        chefId: props.userId
      }
    })
  }),
  graphql(GET_CALENDAR_SLOTS, {
    name: "monthlySlots",
    options: props => ({
      variables: {
        chefId: props.userId,
        start: moment(props.scheduleMonth, 'MM')
          .startOf("month")
          .format("YYYY-MM-DD"),
        end: moment(props.scheduleMonth, 'MM')
          .endOf("month")
          .format("YYYY-MM-DD")
      },
      fetchPolicy: "network-only"
    })
  })
)(Schedule);
const ChefSchedule = connect(mapStateToProps)(ChefScheduleWithData);

export default ChefSchedule;
